import { firestore } from '../firebase';
import { doc, getDoc, collection, query, where, getDocs } from 'firebase/firestore';

/**
 * Get the brand (montadoraMKT) for the first seller with available stock
 * @param {Array} sellers - Array of seller objects with stock information
 * @returns {Promise<string|null>} - The brand name or null if not found
 */
export const getSellerBrandByStock = async (sellers) => {
  try {
    // Find the first seller with stock > 0
    const firstSellerWithStock = sellers?.find(seller => seller.stock > 0);
    
    if (!firstSellerWithStock) {
      // console.log('No seller with stock found');
      return null;
    }

    const sellerName = firstSellerWithStock.name;
    // console.log('First seller with stock:', firstSellerWithStock);
    // console.log('Seller name for brand lookup:', sellerName);

    // Fetch brand data from Firestore
    const dealersRef = collection(firestore, 'dealers');
    const q = query(dealersRef, where('nome', '==', sellerName));
    const querySnapshot = await getDocs(q);
    
    if (!querySnapshot.empty) {
      const doc = querySnapshot.docs[0]; // Get the first matching document
      const dealerData = doc.data();
      // console.log('Dealer data for', sellerName, ':', dealerData);
      // console.log('Montadora MKT value:', dealerData.montadoraMKT);
      return dealerData.montadoraMKT || null; // Return montadoraMKT value or null if not found
    }
    
    // console.log('No dealer found for seller:', sellerName);
    return null; // Return null if no matching dealer found
  } catch (error) {
    // console.error('Error fetching seller brand:', error);
    return null;
  }
};

/**
 * Get the first seller with available stock
 * @param {Array} sellers - Array of seller objects with stock information
 * @returns {Object|null} - The first seller with stock > 0 or null if none found
 */
export const getFirstSellerWithStock = (sellers) => {
  return sellers?.find(seller => seller.stock > 0) || null;
};

/**
 * Get the name of the first seller with available stock
 * @param {Array} sellers - Array of seller objects with stock information
 * @returns {string|null} - The name of the first seller with stock > 0 or null if none found
 */
export const getFirstSellerNameWithStock = (sellers) => {
  const firstSellerWithStock = getFirstSellerWithStock(sellers);
  return firstSellerWithStock?.name || null;
}; 